import { getData } from "../../api";
import { Website_Type } from "../../common";

// Blog
export const blog = async (page = "") => {
  try {
    return await getData(`/blog?page=${page}`);
  } catch (error) {
    console.log(error);
  }
};

export const blogDetails = async (id) => {
  try {
    return await getData(`/blog/${id}`);
  } catch (error) {
    console.log(error);
  }
};

// Faq

export const faqCategoryLuxury = async (id) => {
  try {
    return await getData(`/luxury/faq?website_type_id=${Website_Type.Luxury}`);
  } catch (error) {
    console.log(error);
  }
};

export const FaqDataLuxury = async (id) => {
  try {
    return await getData(
      `/luxury/faq/${id}?website_type_id=${Website_Type.Luxury}`,
    );
  } catch (error) {
    console.log(error);
  }
};

export const FaqAllDataLuxury = async (id) => {
  try {
    return await getData(
      `/luxury/faq/all?website_type_id=${Website_Type.Luxury}`,
    );
  } catch (error) {
    console.log(error);
  }
};
